import MovableRouteCard from "./MovableRouteCard";

const cardHeight = 140;

export default function MovableRouteCards({routes = []}) {

    const cardsWrapp = React.useRef()
    const cardsContainer = React.useRef()
    const routesTransformed = [routes[0], ...routes].map((route) => ({route}))
    const [isHovered, setIsHovered] = React.useState(false);

    const closedHeight = cardHeight + routes.length * 10;

    React.useEffect(() => {
        const handleMouseEnter = () => setIsHovered(() => true);
        const handleMouseLeave = () => setIsHovered(() => false);

        if (cardsContainer.current) {
            const $cardsWrapper = $(cardsContainer.current);
            $cardsWrapper.on('mouseenter', handleMouseEnter);
            $cardsWrapper.on('mouseleave', handleMouseLeave);
        }

        return () => {
            if (cardsContainer.current) {
                const $cardsWrapper = $(cardsContainer.current);
                $cardsWrapper.off('mouseenter', handleMouseEnter);
                $cardsWrapper.off('mouseleave', handleMouseLeave);
            }
        }
    }, [])

    if (routes.length === 0)
        return null;

    return <div ref={cardsWrapp} className="offer-modal__cards-wrapp"
                style={{ height: (closedHeight - 10) + 'px' }}>
        <div ref={cardsContainer}
             className={cn("offer-modal__cards", isHovered && 'open')}
             style={{ marginTop: isHovered ? (routes.length * 10) + 'px' : 0 }}>
            {routesTransformed.map(({route}, index) => <MovableRouteCard 
                key={`route${index}`} 
                route={route} 
                cardHeight={cardHeight}
                index={index} 
                count={routes.length} 
                isHovered={isHovered} 
            />)}
        </div>
    </div>
}